<template>
  <div
    v-if="list.meta"
    :class="list.meta.list_type"
    class="website-list"
  >
    <template v-for="(item, key) in list.data">
      <component
        :is="list.component"
        :item="item"
        :key="key"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'website-list',
  props: {
    list: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>
